import Vue from 'vue'
import AV from 'leancloud-storage'

export default {
  install: function (Vue, options) {
    Vue.prototype.$initWechat = function () {
      return new Promise((resolve, reject) => {
        let userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("micromessenger") < 0) {
          resolve();
          return
        }

        AV.Cloud.run('getSignatureForWechatWeb', { url: location.href }).then((res) => {
          this.$wechat.config({
            // debug: process.env.NODE_ENV !== "production",
            debug: false,
            appId: "wx722a2cb8530f222f",
            timestamp: res.timestamp,
            nonceStr: res.noncestr,
            signature: res.signature,
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "onMenuShareQZone"]
          })

          this.$wechat.ready(function () {
            resolve()
          })
        }).catch((err) => {
          reject(err)
        })
      })
    }

    Vue.prototype.$initWechatShare = function (options) {
      // 朋友圈
      this.$wechat.onMenuShareTimeline({
        title: options.title,
        link: options.link,
        imgUrl: options.image,
        success: () => {
          this.$vux.toast.show({
            text: '分享成功'
          })
        },
        cancel: () => {
          // this.$vux.toast.show({
          //   text: '分享失败',
          //   type: 'text'
          // })
        }
      })

      // 朋友
      this.$wechat.onMenuShareAppMessage({
        title: options.title,
        link: options.link,
        imgUrl: options.image,
        desc: options.desc,
        success: () => {
          this.$vux.toast.show({
            text: '分享成功'
          })
        },
        cancel: () => {
          // this.$vux.toast.show({
          //   text: '分享失败',
          //   type: 'text'
          // })
        }
      })

      // QQ
      this.$wechat.onMenuShareQQ({
        title: options.title,
        link: options.link,
        imgUrl: options.image,
        desc: options.desc,
        success: () => {
          this.$vux.toast.show({
            text: '分享成功'
          })
        },
        cancel: () => {
          // this.$vux.toast.show({
          //   text: '分享失败',
          //   type: 'text'
          // })
        }
      })

      // 腾讯微博
      this.$wechat.onMenuShareWeibo({
        title: options.title,
        link: options.link,
        imgUrl: options.image,
        desc: options.desc,
        success: () => {
          this.$vux.toast.show({
            text: '分享成功'
          })
        },
        cancel: () => {
          // this.$vux.toast.show({
          //   text: '分享失败',
          //   type: 'text'
          // })
        }
      })

      // QQ空间
      this.$wechat.onMenuShareQZone({
        title: options.title,
        link: options.link,
        imgUrl: options.image,
        desc: options.desc,
        success: () => {
          this.$vux.toast.show({
            text: '分享成功'
          })
        },
        cancel: () => {
          // this.$vux.toast.show({
          //   text: '分享失败',
          //   type: 'text'
          // })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/initWechat.js